export const MAX_AUTO_POST_WOO_PRODUCTS = 1000;
export const MAX_AUTO_POST_WOO_PRODUCT_IMAGES = 4;
export const MAX_AUTO_POST_WOO_SHORT_DESCRIPTION_LENGTH = 500;

const normalizeString = (value) => String(value || "").trim();

const truncateText = (
  value,
  maxLength = MAX_AUTO_POST_WOO_SHORT_DESCRIPTION_LENGTH,
) => {
  const text = normalizeString(value).replace(/\s+/g, " ");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 3).trim()}...`;
};

const normalizeProductImage = (image = {}, fallbackAlt = "") => {
  const src = normalizeString(image?.src || image?.thumbnail);
  if (!src) return null;

  return {
    src,
    thumbnail: normalizeString(image?.thumbnail || image?.src),
    alt: normalizeString(image?.alt || fallbackAlt),
  };
};

export const buildSelectedWooProductsForSave = (products = []) => {
  if (!Array.isArray(products)) {
    return [];
  }

  return products
    .slice(0, MAX_AUTO_POST_WOO_PRODUCTS)
    .map((product) => {
      const name = normalizeString(product?.name);
      const permalink = normalizeString(product?.permalink);
      if (!name || !permalink) {
        return null;
      }

      const normalizedImages = Array.from(
        new Map(
          [
            ...(product?.image ? [product.image] : []),
            ...(Array.isArray(product?.images) ? product.images : []),
          ]
            .map((image) => normalizeProductImage(image, name))
            .filter(Boolean)
            .map((image) => [image.src, image]),
        ).values(),
      ).slice(0, MAX_AUTO_POST_WOO_PRODUCT_IMAGES);

      return {
        id: product.id ?? null,
        name,
        permalink,
        shortDescription: truncateText(
          product.shortDescription ||
            product.short_description ||
            product.description ||
            "",
        ),
        priceText: normalizeString(product.priceText),
        currencyCode: normalizeString(product.currencyCode),
        image: normalizeProductImage(product.image, name) || normalizedImages[0] || null,
        images: normalizedImages,
      };
    })
    .filter(Boolean);
};
